<template>
  <BaseTemplate>
    <div class="rewards-coming-soon">
      <img :src="comingSoonImage" alt="Rewards Coming Soon" />
    </div>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';

export default {
  name: 'Rewards',
  components: {
    BaseTemplate,
  },
  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
    }),
    comingSoonImage() {
      if (this.currentUser && String(this.currentUser.country_id) === '84') {
        return '/img/rewards_coming_soon_jp.png';
      }
      return '/img/rewards_coming_soon.png';
    },
  },
};
</script>

<style lang="scss" scoped>
.rewards-coming-soon {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 60vh;
  padding: 20px;
  img {
    max-width: 100%;
    height: auto;
  }
}
</style>
